// import

import cx from 'clsx';
import {styled} from 'goober';
import type {ComponentProps} from 'react';
import {useForm} from 'react-hook-form';

import {Bell} from 'modules/Icon';
import {SignupForm} from 'modules/SignupForm';
import type {ColorKey} from 'modules/Theme/theme';
import {Type} from 'modules/Type';

// types

type Props = ComponentProps<typeof Block> & {
  buttonText: string;
  buttonColor?: ColorKey;
  groups: string[];
};

// component

export function NotifyForm(props: Props) {
  const {buttonText, groups, buttonColor = 'blue', ...rest} = props;
  const form = useForm();

  return (
    <Block {...rest}>
      <Type className="signup">
        <SignupForm
          buttonClass={cx('button', buttonColor)}
          buttonText={(
            <>
              <Bell className="buttonIcon" />{buttonText}
            </>
          )}
          className="form"
          form={form}
          groups={groups}
          inputClass="input"
          placeholder="author@email.com"
        />
      </Type>
    </Block>
  );
}

// styles

const Block = styled('div')`
  max-width: 45rem;

  .success {
    color: var(--green);
  }

  .error {
    color: var(--red);
  }

  .form {
    display: flex;
    flex-flow: row nowrap;

    & .input {
      height: calc(3rem + var(--rpx));
      border-right-width: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    & .button {
      height: 3rem;
      flex: 1 0 auto;
      white-space: nowrap;
    }
  }

  .buttonIcon {
    display: inline-block;
    margin-bottom: 0;
    margin-right: 0.25rem;
    position: relative;
    top: 0.375rem;
    width: 1.5rem;
  }

  @media (min-width: 36em) and (max-width: 53.99875em) {
    max-width: 36rem;
  }

  @media (max-width: 35.99875em) {
    .region {
      padding-top: 4.5rem;
      padding-bottom: 4.5rem;
    }
  }
`;
